import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({ breakpoints, fontWeights }: Theme) => ({
  title: {
    margin: '0 0 1.5rem',
    fontSize: '1.25rem',
    lineHeight: 1.4,
    fontWeight: fontWeights.medium,
    [breakpoints.up('sm')]: {
      marginBottom: '0.5rem',
      fontSize: '1.75rem',
    },
  },
  text: {
    margin: '0 0 1.5rem',
    [breakpoints.up('sm')]: {
      marginBottom: '2rem',
    },
  },
  contentStyles: {
    [breakpoints.up('sm')]: {
      paddingLeft: '3rem',
      paddingRight: '3rem',
    },
  },
  paperStyles: {
    '&&': {
      width: '34.875rem',
      maxWidth: '90vw',
      paddingTop: '1.5rem',
      paddingBottom: '1.5rem',
      borderRadius: '0.5rem',
      [breakpoints.up('sm')]: {
        paddingTop: '3rem',
        paddingBottom: '3rem',
      },
    },
  },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0.75rem',
    marginTop: '1.5rem',
    [breakpoints.up('sm')]: {
      marginTop: '2rem',
    },
  },
}));
